module.exports = __webpack_public_path__ + "img/open_in_new.d658ee76.svg";